import type { ReportOptionItem } from '@/core/models/report-options.models';

const NOT_OFFERED = ['LARGE'];

const upper = (value: string | null | undefined) => (value ?? '').trim().toUpperCase();

/**
 * Company Size choices: Micro Entity, Small Company and Medium Company (Testing Flows: Micro -> FRS 105, Small -> FRS 102 1A,
 * Medium -> full FRS 102); Large is not offered (issue #35). A client that already holds Large keeps it in the list, so the
 * field does not go blank - nothing here changes a saved value.
 */
export function companySizeChoices(
  sizes: ReportOptionItem[],
  currentSize: string | null | undefined,
): ReportOptionItem[] {
  return sizes.filter((item) => !NOT_OFFERED.includes(upper(item.code)) || upper(item.code) === upper(currentSize));
}
